import Vue from 'vue';

Vue.component('stock-receive-index', () =>
    import(/* webpackChunkName: 'stock-receive-index' */ './stock-receive-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/stock-receive/index.js